import { poppins300 } from 'theme/common.style';

export const activityCont = {
  borderRadius: '8px',
  // boxShadow: `0px 1px 8px ${shadowColor}`,
  border: '1px solid #E4E4E4',
  width: '90%',
  marginLeft: '20px',
  padding: '14px',
  marginTop: '15px',
  marginBottom: '0px',
};

export const activityContCard = {
  borderRadius: '8px',
  // boxShadow: `0px 1px 8px ${shadowColor}`,
  border: '1px solid #E4E4E4',
  width: '95%',
  marginLeft: '15px',
  padding: '14px',
  marginTop: '15px',
  marginBottom: '0px',
};

export const activityContSmall = {
  borderRadius: '8px',
  // boxShadow: `0px 1px 8px ${shadowColor}`,
  border: '1px solid #E4E4E4',
  width: '90%',
  marginLeft: '10px',
  padding: '14px',
  marginTop: '15px',
  marginBottom: '0px',
};
export const displayFlex = {
  display: 'flex',
  flexDirection: 'column !important',
  gap: '10px',
};

export const circleCont = {
  borderRadius: '50%',
  textAlign: 'center',
  display: 'flex',
  padding: '9px',
  // marginTop:"15px",
  background: '#FFFFFF',
  boxShadow: '0px 1px 6px rgba(0, 0, 0, 0.15)',
};

export const labelCont = {
  textAlign: 'center',
  margin: '20px',
  ...poppins300,
};

export const displayFlexRow = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  // border : '1px solid red'
};

export const imageCont = {
  ...displayFlexRow,
  alignItems: 'center',
};

export const userDetCont = {
  padding: '10px',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  border: 'none',
};
